import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';
import { QuestionsContext } from '../../context/Questions';
import { AppContext } from '../../context/App-context';
import HttpAxios from '../../hooks/http';
import { useUserMe } from '../../hooks/userme';
import { useQuestionsMe } from '../../hooks/questionsme';
import { EErrorMsg } from '../../statics/controls';
import { IUserMe } from '../../interfaces/user';
import IconClose from '../../../images/close.svg';
import './modal.scss';

interface IDialog {
    title: string;
    text: string;
    isOpenState?: boolean;
}

function Modal(props: IDialog) {
    const { title, text } = props;
    const history = useHistory();
    const { showModalApply, changeShowModalApply } =
        useContext(QuestionsContext);
    const { changeIsLoading, changeSnackBar } = useContext(AppContext);
    const [userMe, setUserMe] = useUserMe();
    const [questionsMe] = useQuestionsMe();
    const [rest, setRest] = useState<number>(0);

    const publish = () => {
        changeIsLoading(true);
        HttpAxios.post('/forms/publish', {})
            .then((res: any) => {
                const { err } = res?.data || {};
                if (err) {
                    changeSnackBar(err);
                    changeIsLoading(false);
                    changeShowModalApply(false);
                } else {
                    let userMeUpdated = (userMe as IUserMe) || {};
                    userMeUpdated.postulacionenviada = true;
                    setUserMe({ ...userMeUpdated });
                    changeShowModalApply(false);
                    changeIsLoading(false);
                    history.push('/thanks');
                }
            })
            .catch(() => {
                changeSnackBar(EErrorMsg.generic);
                changeIsLoading(false);
                changeShowModalApply(false);
            });
    };

    useEffect(() => {
        questionsMe &&
            setRest(
                questionsMe.total_preguntas - questionsMe.total_respondidas
            );
    }, [questionsMe]);

    return (
        <>
            <Transition
                show={showModalApply}
                enter="ModalQEnter"
                enterFrom="ModalQEnterFrom"
                enterTo="ModalQEnterTo"
                leave="ModalQLeave"
                leaveFrom="ModalQLeaveFrom"
                leaveTo="ModalQLeaveTo"
            >
                <Dialog
                    className="ModalQ"
                    onClose={() => changeShowModalApply(false)}
                >
                    <Dialog.Overlay className="ModalQOverlay" />

                    <div className="ModalQContent bgLinear">
                        <Dialog.Title className="ModalQTitle">
                            {title}
                        </Dialog.Title>
                        <Dialog.Description className="ModalQDerscription">
                            {text}
                            {questionsMe && (
                                <span className="ModalQDerscriptionQuestions">
                                    {rest > 0 ? (
                                        <>
                                            Te queda {rest} pregunta
                                            {rest === 1 ? '' : 's'} por
                                            responder
                                        </>
                                    ) : (
                                        <>Respondiste todas las preguntas</>
                                    )}
                                </span>
                            )}
                        </Dialog.Description>
                        <div className="ModalQActions">
                            <div className="mbm">
                                <button
                                    className="button buttonSecondary ModalQContinue"
                                    onClick={publish}
                                >
                                    Enviar postulación
                                </button>
                            </div>
                            <div className="mb1">
                                <button
                                    className="button buttonLink ModalQContinue"
                                    onClick={() => changeShowModalApply(false)}
                                >
                                    Seguir editando postulación
                                </button>
                            </div>
                        </div>
                        <button
                            className="ModalQClose"
                            onClick={() => changeShowModalApply(false)}
                        >
                            <img src={IconClose} alt="Close" />
                        </button>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}

export default Modal;
